import { observer } from "mobx-react";
import { FC, useEffect } from "react";
import { ArticleSelectorQuestion } from "@/dbot/common/commonComponents";
import { ChangeBusinessPurposeForm } from "./changeBusinessPurposeDomain";
import { Box, VBox } from "@/components-v2/Box";
import { MTextArea } from "@/components-v2/TextArea";
import { useTranslation } from "@/stores/RootStoreContext";
import { LocalizedStringFieldModel } from "@/common/commonForms";

export const ChangeBusinessPurposeView: FC<{ form: ChangeBusinessPurposeForm }> = observer(
  ({ form }) => {
    const { t } = useTranslation();

    useEffect(() => form.init(), [form]);

    return (
      <VBox gap={"md"}>
        <LocalizedBusinessPurposeQuestion
          question={t("decisions.businessPurpose.newPurpose")}
          name={"business-purpose"}
          textModels={form.texts}
          isLocked={form.isProjectLocked}
        />
        <ArticleSelectorQuestion
          question={t("decisions.businessPurpose.what-paragraph")}
          onChange={form.setParagraphValue}
          model={form.paragraph}
          isLocked={form.isProjectLocked}
        />
      </VBox>
    );
  },
);

const LocalizedBusinessPurposeQuestion = observer(
  ({
    textModels,
    name,
    question,
    isLocked,
  }: {
    textModels: LocalizedStringFieldModel[];
    name: string;
    question: string;
    isLocked: boolean;
  }) => {
    const { t } = useTranslation();

    if (!textModels.length) {
      return null;
    }

    return (
      <VBox>
        <div>{question}</div>
        {textModels.map((tm) => (
          <Box key={tm.locale}>
            <MTextArea
              name={`${name}-${tm.locale}`}
              label={textModels.length > 1 ? t(`language.${tm.locale}`) : undefined}
              model={tm.model}
              disabled={isLocked}
              rows={4}
              expandable
            />
          </Box>
        ))}
      </VBox>
    );
  },
);
